module.exports = __webpack_public_path__ + "static/media/revista_dic2008.dd30b3cb.png";